import api from "./apiConfig";

export const REGISTER_SUGGESTION = async (data) => {
	try {
		const response = await api.post("/suggestions", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};